import {
  FormControlLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {IStation} from '../../../../dto/Station.dto';
import {IPrimaryStations} from './OnboardingStationsRequest';
import {IOSSwitch} from '../../../../components/styles/ToggleButton';

const StationLabeling = ({
  stations,
  setStations,
  primaryStations,
  setPrimaryStations,
  type,
}: {
  stations: IStation[];
  setStations: React.Dispatch<React.SetStateAction<IStation[]>>;
  primaryStations: IPrimaryStations;
  setPrimaryStations: React.Dispatch<React.SetStateAction<IPrimaryStations>>;
  type: keyof IPrimaryStations;
}) => {
  return (
    <>
      {stations.map(val => {
        return val.type === type ? (
          <StationsNamingCmpt
            key={val.id}
            station={val}
            type={type}
            stations={stations}
            setStations={setStations}
            primaryStations={primaryStations}
            setPrimaryStations={setPrimaryStations}
          />
        ) : null;
      })}
    </>
  );
};

export default StationLabeling;

type K = keyof IStation;

const StationsNamingCmpt = ({
  station,
  stations,
  setStations,
  primaryStations,
  setPrimaryStations,
  type,
}: {
  station: IStation;
  stations: IStation[];
  setStations: React.Dispatch<React.SetStateAction<IStation[]>>;
  primaryStations: IPrimaryStations;
  setPrimaryStations: React.Dispatch<React.SetStateAction<IPrimaryStations>>;
  type: keyof IPrimaryStations;
}) => {
  const handleOnChange = (value: IStation[K], id: number, type: K) => {
    setStations(prev => {
      const data = prev.map(val => {
        if (val.id === id && value !== ' ') {
          const stationData = {...val, [type]: value};
          return stationData;
        }
        return val;
      });

      return data;
    });
  };
  const handleOnclick = (id: number, val: boolean) => {
    setPrimaryStations(prev => {
      if (val) {
        return {...prev, [type]: id};
      } else {
        return {...prev, [type]: 0};
      }
    });
  };
  return (
    <>
      <Stack direction={'row'} spacing={2} mt={2} alignItems={'center'}>
        {type === 'mirror_station' ? (
          <Select
            labelId='select-label'
            id='select'
            value={`${station.parent_id}`}
            label='Full station'
            fullWidth
            onChange={e =>
              handleOnChange(e.target.value, station.id, 'parent_id')
            }>
            {stations.map((station: IStation) => {
              if (station.type === 'full_station') {
                return (
                  <MenuItem value={station.id} key={station.id}>
                    {station.name}
                  </MenuItem>
                );
              }
              return null;
            })}
          </Select>
        ) : null}
        <TextField
          size='small'
          variant='outlined'
          id='name'
          label='Name'
          fullWidth
          value={station.name}
          onChange={e => handleOnChange(e.target.value, station.id, 'name')}
        />
        <TextField
          size='small'
          variant='outlined'
          id='label'
          label='Label'
          fullWidth
          value={station.label}
          onChange={e => handleOnChange(e.target.value, station.id, 'label')}
        />
        {type !== 'mirror_station' ? (
          <Stack direction={'column'} width={'100px'}>
            <Typography variant='caption' width={'100%'}>
              Primary Station
            </Typography>
            <FormControlLabel
              className='ml-2'
              label=''
              control={<IOSSwitch defaultChecked />}
              onClick={() =>
                handleOnclick(
                  station.id,
                  !Boolean(station.id === primaryStations[type]),
                )
              }
              checked={station.id === primaryStations[type]}
            />
          </Stack>
        ) : null}
      </Stack>
    </>
  );
};
